import { render, staticRenderFns } from "./SubscriptionExpressSendMessage.vue?vue&type=template&id=6b337049&scoped=true"
import script from "./SubscriptionExpressSendMessage.vue?vue&type=script&lang=ts"
export * from "./SubscriptionExpressSendMessage.vue?vue&type=script&lang=ts"
import style0 from "./SubscriptionExpressSendMessage.vue?vue&type=style&index=0&id=6b337049&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b337049",
  null
  
)

export default component.exports